import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=65c6ebc2&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Modal.vue?vue&type=style&index=0&id=65c6ebc2&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "65c6ebc2",
  null
  ,true
)

export default component.exports